import i18n from 'modules/core/lib/i18n'

interface PeriodicityDataProps {
  label: string
  recurrence: string
}

export type PeriodicityType = 'monthly' | 'every_2_weeks' | 'twice_a_month' | 'weekly'

const periodicities = (): { [key in PeriodicityType]: PeriodicityDataProps } => {
  return {
    monthly: {
      recurrence: 'FREQ=MONTHLY;BYMONTHDAY=1',
      label: i18n.t('payroll_bundle.payroll_policy.periodicity.monthly'),
    },
    every_2_weeks: {
      recurrence: 'FREQ=WEEKLY;INTERVAL=2;WKST=SU',
      label: i18n.t('payroll_bundle.payroll_policy.periodicity.every_2_weeks'),
    },
    twice_a_month: {
      recurrence: 'FREQ=MONTHLY;BYMONTHDAY=1,15',
      label: i18n.t('payroll_bundle.payroll_policy.periodicity.twice_a_month'),
    },
    weekly: {
      recurrence: 'FREQ=WEEKLY;BYDAY=MO',
      label: i18n.t('payroll_bundle.payroll_policy.periodicity.weekly'),
    },
  }
}

export const periodicityByRecurrence = (recurrence: string): PeriodicityDataProps | undefined => {
  return Object.values(periodicities()).find(
    (value: PeriodicityDataProps) => value.recurrence === recurrence
  )
}
